// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class StreamingTechnologyDto extends ItiBaseDto {
	public taskTypeDesc: string;
	public taskTypeId: number;
	public technologyId: number;
	public technologyName: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
